import i18n from '../i18n'

export function getDateFormat(dateBegin: string, dateEnd: string, language: string) {
  const begin = new Date(dateBegin)
  const end = new Date(dateEnd)

  const beginOptions: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: language === 'en_EN' ? 'long' : undefined,
  }
  const differentYear = begin.getFullYear() !== end.getFullYear()
  const differentMonth = begin.getMonth() !== end.getMonth()

  if (differentMonth) {
    beginOptions.month = 'long'
  }

  if (differentYear) {
    beginOptions.year = 'numeric'
  }

  const beginText = `${begin.toLocaleDateString(language.replace('_', '-'), beginOptions)}${
    language === 'de_DE' && !beginOptions.month ? '.' : ''
  }`
  const endText = differentMonth
    ? language === 'en_EN'
      ? `${end.toLocaleDateString(language.replace('_', '-'), {
          month: 'long',
        })} ${end.getDate()} ${end.getFullYear()}`
      : `${end.getDate()}${language === 'de_DE' ? '.' : ''} ${end.toLocaleDateString(
          language.replace('_', '-'),
          { month: 'long' },
        )} ${end.getFullYear()}`
    : `${end.getDate()}${language === 'de_DE' ? '.' : ''} ${
        language !== 'en_EN'
          ? end.toLocaleDateString(language.replace('_', '-'), { month: 'long' })
          : ''
      } ${end.getFullYear()}`

  return `${i18n.t('cruise.from')} ${beginText} ${i18n.t('cruise.to')} ${endText}`
}
